import { useSite } from "@/context/SiteContext";
import { CampaignProgress } from "@/components/site/CampaignProgress";
import { DonateForm } from "@/components/site/DonateForm";
import { DonorWall } from "@/components/site/DonorWall";
import { SectionHead, DoodleBand, LightSection } from "@/components/site/Shared";
import { money } from "@/lib/api";

const STAT_COLORS = ["bg-aqua", "bg-mustard", "bg-quartz"];

export default function Donate() {
  const { settings: s } = useSite() || {};
  if (!s) return <div className="h-[80vh]" />;
  const stats = [[money(s.campaign_goal), "goal"], [`${s.campaign_years} yrs`, "of free programs"], [`${s.events_per_year}+`, "events a year"]];
  return (
    <div data-testid="donate-page">
      <section className="container-mas py-12 sm:py-16 grid lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-6 space-y-8 rise">
          <div>
            <p className="eyebrow-dark mb-4">fundraising campaign</p>
            <h1 className="font-sans font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1]">{s.campaign_title}</h1>
            <p className="mt-5 text-base sm:text-lg text-shell/75 font-light leading-relaxed">{s.campaign_blurb}</p>
          </div>
          <CampaignProgress variant="dark" testid="donate-campaign-progress" />
          <div className="grid grid-cols-3 gap-2">
            {stats.map(([a, b], i) => (
              <div key={b} className={`${STAT_COLORS[i]} text-ink p-4`}>
                <p className="font-display text-xl sm:text-2xl">{a}</p>
                <p className="font-mono text-[10px] uppercase tracking-wider mt-1">{b}</p>
              </div>
            ))}
          </div>
          <div className="bg-ink2 p-6">
            <p className="eyebrow-dark mb-4">what your gift makes possible</p>
            <ol className="space-y-3">
              {(s.contribution_levels || []).map((c, i) => (
                <li key={i} className="flex gap-4 items-baseline"><span className="font-display text-xl text-tang w-20 shrink-0">{money(c.amount)}</span><span className="text-sm font-light">{c.outcome}</span></li>
              ))}
            </ol>
          </div>
        </div>
        <div className="lg:col-span-6 lg:sticky lg:top-28 self-start rise" style={{ animationDelay: ".1s" }}><DonateForm /></div>
      </section>
      <DoodleBand />
      <LightSection id="donor-wall">
        <div className="container-mas py-16 sm:py-20">
          <SectionHead light eyebrow="donor wall" title="Thank you, in ink" intro="Donors choose how they appear: name and amount, name only, or anonymous. Messages are reviewed before they're posted." className="mb-10" />
          <DonorWall />
        </div>
      </LightSection>
    </div>
  );
}
